export const hasPermission = (user, resource, action = 'read') => {
  if (!resource || !action) return true;
  if (user?.is_superuser) return true;

  const rights = user?.rights || {};
  if (Array.isArray(rights[resource]) && rights[resource].includes(action)) {
    return true;
  }

  return Array.isArray(user?.permission_codes)
    && user.permission_codes.includes(`${resource}.${action}`);
};

export const hasAnyPermission = (user, permissions = []) => (
  permissions.some(({ resource, action = 'read' }) => hasPermission(user, resource, action))
);

export const isRestrictedVendor = (user) => Boolean(user?.is_vendor && !user?.is_superuser);
